import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import BrandedButton from '../../../../../Buttons/BrandedButton';
import { MODAL_FOOTER_BUTTON_SIZE, MODAL_FOOTER_PRIMARY_BUTTON_MIN_WIDTH } from '../../../Modal';
const ConfirmButton = (_param)=>{
    var { children, variant = 'brand-green' } = _param, rest = _object_without_properties(_param, [
        "children",
        "variant"
    ]);
    return /*#__PURE__*/ React.createElement(BrandedButton, _object_spread({
        size: MODAL_FOOTER_BUTTON_SIZE,
        style: {
            minWidth: MODAL_FOOTER_PRIMARY_BUTTON_MIN_WIDTH
        },
        variant: variant
    }, rest), children);
};
ConfirmButton.displayName = 'ConfirmButton';
export default ConfirmButton;

//# sourceMappingURL=ConfirmButton.js.map